import { render } from "./forget-form.vue?vue&type=template&id=0ec3bd95&ts=true"
import script from "./forget-form.vue?vue&type=script&lang=ts"
export * from "./forget-form.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__